<i18n src="./translations"></i18n>

<template>
  <span :class="classes" :data-preload="[$options.name]">
    <span :class="label">
      {{ label }}
    </span>

    <span>{{ value }}</span>

    <span v-if="isBusinessCustomer" class="price--business-net">
      {{ $t('price.business-net') }}
    </span>
  </span>
</template>
<script>
import { mapGetters } from 'vuex';

import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'Price',
  mixins: [globalMixin],
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('core', ['isBusinessCustomer']),
  },
};
</script>

<style scoped lang="scss">
@import 'variables/breakpoints';
@import 'mixins';

.price {
  display: block;
  white-space: nowrap;
  // text-align: right;

  color: var(--color-mine-shaft);

  &--inline {
    display: inline-block;
    color: inherit;
  }

  &--bold {
    font-weight: bold;
  }

  &--big {
    text-align: left;
    font-weight: bold;
    font-size: 40px;
    color: var(--color-chathamsblue);
  }

  &--com {
    color: var(--color-primary);
  }

  &--highlighted {
    color: var(--color-chathamsblue);
  }

  &--outdated {
    color: var(--color-chathamsblue);
    text-decoration: line-through;
  }

  &--business-net {
    font-size: var(--font-size-M);
    font-weight: normal;
  }
}
</style>
